
import GoogleMaterialIcon from '@/components/icons/google-material-icon/google-material-icon';
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';

@Component({
    name: 'input-number',
    components: {
        'material-icons': GoogleMaterialIcon,
    },
})

export default class InputNumber extends Vue {

    // --------------------------------------------------------------------
    // Properties

    @Prop({ default: 30 })
    private value: any;

    @Prop()
    private isReadOnly: any;

    private isExpand: boolean = false;

    private propInput: any = null;

    // ---------------------------------------------------------------------
    // Methods

    private created() {
        this.propInput = this.value;
    }

    private mounted() {
        this.$emit('input', this.propInput);
    }

    private onUpdate(value: any) {
        this.$emit('input', value);
    }

}
